import SharedHeader from "@/components/SharedHeader";
import LandingFooter from "@/components/landing/LandingFooter";
import FloatingContactButtons from "@/components/FloatingContactButtons";
import MobileBottomNav from "@/components/landing/MobileBottomNav";
import { useApp } from "@/lib/AppContext";

export default function AboutPage() {
  const { lang } = useApp();
  const isAr = lang === "ar";

  return (
    <div className="min-h-screen bg-background" dir={isAr ? "rtl" : "ltr"}>
      <SharedHeader />
      <div className="pt-16 pb-24 md:pb-0">
        <section className="py-16">
          <div className="max-w-3xl mx-auto px-4 space-y-6">
            <div className="text-center mb-8">
              <img
                src="https://media.base44.com/images/public/user_69729b1c2410c5c031f1d29a/291b90bb1_.png"
                alt="logo"
                className="w-24 h-24 object-contain mx-auto mb-4"
              />
              <h1 className="text-3xl sm:text-4xl font-black text-foreground mb-2">
                {isAr ? "من نحن" : "About Us"}
              </h1>
            </div>

            {isAr ? (
              <div className="space-y-4 text-foreground leading-relaxed text-base">
                <p>
                  تطبيق <strong>مغاسل القمر الأبيض</strong> هو منصة رقمية متكاملة تجمع بين خدمة الغسيل الإلكترونية الاحترافية ونظام عجلة العروض التفاعلية، مصممة خصيصاً لتسهيل حياة العملاء في المملكة العربية السعودية. يتيح التطبيق للمستخدمين طلب خدمات الغسيل والكوي بكل سهولة من خلال هواتفهم الذكية، مع إمكانية اختيار نوع الخدمة المطلوب — سواء كانت غسيل وكوي معاً، غسيل فقط، أو كوي فقط — ومتابعة حالة الطلب خطوة بخطوة من الاستلام حتى التسليم.
                </p>
                <p>
                  يخدم التطبيق عملاء مغاسل القمر الأبيض في منطقة الخبر وما حولها، ويستهدف الأفراد والعائلات الذين يبحثون عن حلول تنظيف موثوقة وسريعة دون عناء الذهاب إلى المغسلة فعلياً. كما يوفر نظام مندوبي توصيل متكامل يضمن استلام الملابس وتسليمها في الوقت المحدد، مع إشعارات فورية لكل مرحلة من مراحل الخدمة.
                </p>
                <p>
                  بالإضافة إلى ذلك، يضم التطبيق لعبة <strong>عجلة العروض</strong> التفاعلية التي تمنح العملاء فرصة للفوز بخصومات وهدايا مميزة عند كل طلب، مما يجعل تجربة استخدام التطبيق أكثر متعة وفائدة. تم تطوير هذا التطبيق وصيانته بواسطة فريق تقني متخصص، بإدارة صاحب العلامة التجارية مغاسل القمر الأبيض، بهدف تقديم تجربة عصرية وسلسة تواكب التطور الرقمي في خدمات الغسيل.
                </p>
              </div>
            ) : (
              <div className="space-y-4 text-foreground leading-relaxed text-base">
                <p>
                  <strong>White Moon Laundry</strong> is an integrated digital platform that combines professional electronic laundry services with an interactive offers wheel system, designed specifically to simplify customers' lives in the Kingdom of Saudi Arabia. The app allows users to request washing and ironing services with ease through their smartphones, with the ability to choose the desired service type — whether wash and iron together, wash only, or iron only — and track the order status step by step from pickup to delivery.
                </p>
                <p>
                  The app serves White Moon Laundry customers in the Khobar area and surrounding regions, targeting individuals and families looking for reliable and fast cleaning solutions without the hassle of physically going to the laundry. It also features an integrated delivery delegate system that ensures clothes are picked up and delivered on time, with instant notifications for each stage of the service.
                </p>
                <p>
                  In addition, the app includes the interactive <strong>Offers Wheel</strong> game that gives customers a chance to win discounts and special gifts with every order, making the app experience more enjoyable and rewarding. This application is developed and maintained by a specialized technical team, managed by the White Moon Laundry brand owner, with the goal of delivering a modern and seamless experience that keeps pace with digital advancement in laundry services.
                </p>
              </div>
            )}
          </div>
        </section>
        <LandingFooter />
        <FloatingContactButtons />
      </div>
      <MobileBottomNav />
    </div>
  );
}